(function () {
  'use strict';

  const q = (root, selector) => root.querySelector(selector);
  const qa = (root, selector) => Array.from(root.querySelectorAll(selector));
  const formatDate = value => value ? new Intl.DateTimeFormat('es-CL', { dateStyle: 'long' }).format(new Date(value)) : '';
  const initial = value => (String(value || '?').trim()[0] || '?').toUpperCase();
  const starPath = 'M12 2.7l2.85 5.78 6.38.93-4.62 4.5 1.09 6.36L12 17.27l-5.7 3 1.09-6.36-4.62-4.5 6.38-.93z';

  function starIcon(filled = true) {
    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('viewBox', '0 0 24 24'); svg.setAttribute('aria-hidden', 'true');
    svg.classList.add(filled ? 'is-filled' : 'is-empty');
    const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    path.setAttribute('d', starPath); svg.append(path);
    return svg;
  }

  function starIcons(rating, className = 'kr-icon-stars') {
    const wrap = element('span', className);
    const filled = Math.max(0, Math.min(5, Math.round(Number(rating || 0))));
    for (let index = 1; index <= 5; index++) wrap.append(starIcon(index <= filled));
    return wrap;
  }

  function element(tag, className, text) {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  }

  function init(root) {
    if (root.dataset.krReady === 'true') return;
    root.dataset.krReady = 'true';
    const endpoint = (root.dataset.endpoint || '/apps/kolder-reviews').replace(/\/$/, '');
    const productId = root.dataset.productId;
    const productHandle = root.dataset.productHandle;
    const productTitle = root.dataset.productTitle;
    let page = 1, sort = '', ratingFilter = '', settings = {}, summary = null;

    const shell = q(root, '[data-kr-shell]');
    const list = q(root, '[data-kr-list]');
    const empty = q(root, '[data-kr-empty]');
    const more = q(root, '[data-kr-more]');
    const dialog = q(root, '[data-kr-dialog]');
    const form = q(root, '[data-kr-form]');
    const status = q(root, '[data-kr-form-status]');
    const steps = qa(root, '[data-kr-step]');
    const backButton = q(root, '[data-kr-back]');
    const nextButton = q(root, '[data-kr-next]');
    const submitButton = q(root, '[data-kr-submit]');
    const wordCounter = q(root, '[data-kr-word-count]');
    let formStep = 1;
    const invitation = new URLSearchParams(location.search).get('review_token') || '';
    form.elements.invitation_token.value = invitation;

    async function fetchReviews(append) {
      const url = `${endpoint}/api/reviews?product_id=${encodeURIComponent(productId)}&product_handle=${encodeURIComponent(productHandle)}&page=${page}&sort=${sort}&rating=${ratingFilter}`;
      const response = await fetch(url, { credentials: 'same-origin', headers: { accept: 'application/json' } });
      if (!response.ok) throw new Error('No se pudieron cargar las reseñas.');
      const data = await response.json();
      settings = data.settings || {};
      summary = data.summary || { count: 0, average: 0, distribution: {} };
      root.style.setProperty('--kr-accent', settings.accent_color || '#0b66c3');
      root.dataset.layout = settings.layout || 'list';
      sort = sort || data.settings?.sort_order || 'newest';
      q(root, '[data-kr-sort]').value = sort;
      q(root, '[data-kr-photo-field]').hidden = !settings.photos_enabled;
      qa(root, '[data-kr-open-form]').forEach(button => button.hidden = !settings.form_enabled);
      renderSummary(data.summary);
      renderReviews(data.reviews || [], append);
      q(root, '[data-kr-heading]').textContent = ratingFilter ? `${data.pagination?.total || 0} con ${ratingFilter} estrellas` : (Number(data.summary?.count) === 1 ? '1 opinión' : `${Number(data.summary?.count || 0)} opiniones`);
      more.hidden = !data.pagination?.has_more;
      shell.hidden = false;
      updateBadges(data.summary);
    }

    function renderSummary(data) {
      const count = Number(data.count || 0), average = Number(data.average || 0);
      q(root, '[data-kr-average]').textContent = average.toLocaleString('es-CL', { minimumFractionDigits: 1, maximumFractionDigits: 1 });
      const summaryStars = q(root, '[data-kr-summary-stars]');
      summaryStars.replaceChildren(starIcons(average));
      q(root, '[data-kr-count]').textContent = count === 1 ? '1 reseña' : `${count} reseñas`;
      const distribution = q(root, '[data-kr-distribution]');
      distribution.replaceChildren();
      for (let rating = 5; rating >= 1; rating--) {
        const value = Number(data.distribution?.[rating] || 0);
        const row = element('div', 'kr-bar');
        const label = element('span', 'kr-bar__label');
        const barStar = element('span', 'kr-bar__star kr-icon-stars');
        barStar.append(starIcon());
        label.append(element('span', '', String(rating)), barStar);
        row.append(label);
        const track = element('span', 'kr-bar__track');
        const fill = element('span', 'kr-bar__fill');
        const percentage = count ? Math.min(100, Math.max(0, Math.round(value / count * 100))) : 0;
        fill.style.width = `${percentage}%`;
        track.append(fill); row.append(track, element('span', '', String(value))); distribution.append(row);
      }
    }

    function renderReviews(reviews, append) {
      if (!append) list.replaceChildren();
      reviews.forEach(review => list.append(reviewNode(review)));
      const hasReviews = list.children.length > 0;
      list.hidden = !hasReviews; empty.hidden = hasReviews;
    }

    function reviewNode(review) {
      const article = element('article', 'kr-review');
      const author = element('div', 'kr-review__author');
      author.append(element('span', 'kr-avatar', initial(review.reviewer_name)));
      const identity = element('div'); identity.append(element('strong', '', review.reviewer_name));
      if (review.verified_purchase && settings.show_verified_badge) identity.append(element('span', 'kr-verified', '✓ Compra verificada'));
      author.append(identity);
      const content = element('div', 'kr-review__content');
      const ratingRow = element('div', 'kr-review__rating');
      ratingRow.append(starIcons(Number(review.rating || 0), 'kr-review__stars kr-icon-stars'), element('time', 'kr-review__date', formatDate(review.published_at || review.created_at)));
      content.append(ratingRow);
      if (review.title) content.append(element('h3', '', review.title));
      content.append(element('p', '', review.body));
      if (Array.isArray(review.photos) && review.photos.length) {
        const photos = element('div', 'kr-review__photos');
        review.photos.forEach(photo => { const img = new Image(); img.src = photo.url; img.alt = photo.alt || 'Fotografía de reseña'; img.loading = 'lazy'; img.width = 92; img.height = 92; photos.append(img); });
        content.append(photos);
      }
      if (review.merchant_reply) { const reply = element('div', 'kr-reply'); reply.append(element('strong', '', 'Respuesta de Kolder'), element('p', '', review.merchant_reply)); content.append(reply); }
      article.append(author, content); return article;
    }

    function updateBadges(data) {
      document.querySelectorAll(`[data-kolder-rating-badge][data-product-id="${CSS.escape(productId)}"]`).forEach(badge => {
        const count = badge.querySelector('.kolder-rating-badge__count'), fill = badge.querySelector('.kolder-rating-badge__fill');
        if (count) count.textContent = `(${Number(data.count || 0)})`;
        if (fill) fill.style.width = `${Number(data.average || 0) * 20}%`;
        badge.classList.toggle('kolder-rating-badge--empty', !Number(data.count));
      });
    }

    function wordCount() { return form.elements.body.value.trim().split(/\s+/).filter(Boolean).length; }
    function setFormStep(step) {
      formStep = Math.max(1, Math.min(3, step));
      steps.forEach(section => { section.hidden = Number(section.dataset.krStep) !== formStep; });
      q(root, '[data-kr-step-label]').textContent = `Paso ${formStep} de 3`;
      q(root, '[data-kr-step-progress]').style.width = `${formStep / 3 * 100}%`;
      backButton.hidden = formStep === 1;
      nextButton.hidden = formStep === 3;
      submitButton.hidden = formStep !== 3;
      status.className = 'kr-form__status'; status.textContent = '';
    }
    function validateStep(step) {
      if (step === 1 && !form.elements.rating.value) { status.classList.add('is-error'); status.textContent = 'Selecciona una calificación para continuar.'; return false; }
      if (step === 2) {
        const words = wordCount();
        if (form.elements.body.value.trim().length < 8) { status.classList.add('is-error'); status.textContent = 'Escribe al menos 8 caracteres.'; return false; }
        if (words > 120) { status.classList.add('is-error'); status.textContent = 'La reseña puede tener un máximo de 120 palabras.'; return false; }
        const files = Array.from(form.elements.photos?.files || []);
        if (files.length > 3) { status.classList.add('is-error'); status.textContent = 'Puedes subir un máximo de 3 fotografías.'; return false; }
      }
      return true;
    }
    function openForm() { setFormStep(1); if (typeof dialog.showModal === 'function') dialog.showModal(); else dialog.setAttribute('open', ''); }
    qa(root, '[data-kr-open-form]').forEach(button => button.addEventListener('click', openForm));
    q(root, '[data-kr-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
    nextButton.addEventListener('click', () => { if (validateStep(formStep)) setFormStep(formStep + 1); });
    backButton.addEventListener('click', () => setFormStep(formStep - 1));
    form.elements.body.addEventListener('input', () => {
      const words = wordCount(); wordCounter.textContent = String(words);
      wordCounter.parentElement.classList.toggle('is-over', words > 120);
    });
    q(root, '[data-kr-sort]').addEventListener('change', event => { sort = event.target.value; page = 1; fetchReviews(false).catch(showLoadError); });
    const filterToggle = q(root, '[data-kr-filter-toggle]'), filters = q(root, '[data-kr-filters]');
    filterToggle.addEventListener('click', () => { const open = filters.hidden; filters.hidden = !open; filterToggle.setAttribute('aria-expanded', String(open)); });
    qa(root, '[data-kr-rating]').forEach(button => button.addEventListener('click', () => {
      ratingFilter = ratingFilter === button.dataset.krRating ? '' : button.dataset.krRating;
      qa(root, '[data-kr-rating]').forEach(option => option.setAttribute('aria-pressed', String(option.dataset.krRating === ratingFilter)));
      page = 1; fetchReviews(false).catch(showLoadError);
    }));
    more.addEventListener('click', () => { page++; fetchReviews(true).catch(showLoadError); });

    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (formStep < 3) { if (validateStep(formStep)) setFormStep(formStep + 1); return; }
      if (!form.elements.reviewer_name.checkValidity() || !form.elements.email.checkValidity()) { form.reportValidity(); return; }
      status.className = 'kr-form__status'; status.textContent = 'Enviando…';
      submitButton.disabled = true;
      try {
        const payload = new FormData(form);
        payload.set('product_id', productId); payload.set('product_handle', productHandle); payload.set('product_title', productTitle);
        const files = payload.getAll('photos').filter(file => file && file.size);
        if (files.length > 3) throw new Error('Puedes subir un máximo de 3 fotografías.');
        const response = await fetch(`${endpoint}/api/reviews`, { method: 'POST', credentials: 'same-origin', body: payload });
        const data = await response.json().catch(() => ({}));
        if (!response.ok) throw new Error(data.error || 'No fue posible enviar la reseña.');
        status.classList.add('is-success'); status.textContent = data.message; form.reset(); form.elements.invitation_token.value = invitation; wordCounter.textContent = '0';
        setTimeout(() => { dialog.close(); setFormStep(1); }, 1800);
        if (data.status === 'approved') { page = 1; await fetchReviews(false); }
      } catch (error) { status.classList.add('is-error'); status.textContent = error.message; }
      finally { submitButton.disabled = false; }
    });

    function showLoadError(error) { console.error(error); shell.hidden = true; }
    const emptyStars = q(root, '[data-kr-empty-stars]');
    if (emptyStars) emptyStars.append(starIcons(0));
    fetchReviews(false).catch(showLoadError);
  }

  function start(scope) {
    qa(scope || document, '[data-kolder-reviews]').forEach(root => {
      if (root.dataset.krReady === 'true' || root.dataset.krObserved === 'true') return;
      if (!('IntersectionObserver' in window)) { init(root); return; }
      root.dataset.krObserved = 'true';
      const observer = new IntersectionObserver(entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        observer.disconnect(); init(root);
      }, { rootMargin: '400px' });
      observer.observe(root);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => start(document), { once: true }); else start(document);
  document.addEventListener('shopify:section:load', event => start(event.target));
}());

